const ArgentineTangoFollow = {
    name: "Argentine Tango",
    bpm: 96,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default ArgentineTangoFollow;